import { FormInput } from '@/features/shiftCloseouts/form/types'
import { ShiftCloseoutPaymentMethod } from '@/features/shiftCloseouts/types'

export const getDefaultValues = (paymentMethods: ShiftCloseoutPaymentMethod[]): FormInput => ({
    actualAmounts: Object.fromEntries(
        paymentMethods.flatMap(({ expectedAmount, mode, paymentType }) =>
            mode === 'manual' && paymentType
                ? ([[paymentType, expectedAmount.amount]] as const)
                : []
        )
    ),
})
